import type { Mission } from '../missions.ts'

export const opm: Mission = {
  id: "opm",
  name: "Office of Personnel Management",
  short: "OPM",
  call: "Workforce",
  kind: "independent",
  url: "https://www.opm.gov/",
  established: 1979,
  palette: {
    primary: "#093453",
    secondary: "#009dd2",
    accent: "#d13038",
  },
  colorSource: {
    kind: "site",
    url: "https://www.opm.gov/cdn/img/opm-uswds/opm_logo.svg",
  },
  motif: "star",
  mission: {
    text: "OPM leads federal agencies in building merit-based, accountable, and modern workforce systems that attract and retain top talent to meet America’s toughest challenges.",
    url: "https://www.opm.gov/about-us/mission-history/",
  },
  fact: {
    text: "OPM's roots date to 1883, when the Pendleton Act created the Civil Service Commission and the competitive civil service.",
    url: "https://www.opm.gov/about-us/mission-history/",
  },
  seal: {
    file: "public/seals/opm.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Office_of_Personnel_Management.svg",
  },
  logo: {
    file: "public/logos/opm.svg",
    source: "https://www.opm.gov/cdn/img/opm-uswds/opm_logo.svg",
  },
  identifier: {
    about: "https://www.opm.gov/about-us/",
    accessibility: "https://www.opm.gov/information-management/accessibility/",
    foia: "https://www.opm.gov/information-management/freedom-of-information-act/",
    noFear: "https://www.opm.gov/about-us/office-of-equal-employment-opportunity/no-fear-act/",
    oig: "https://oig.opm.gov/",
    performance: "https://www.opm.gov/about-us/reports-publications/",
    privacy: "https://www.opm.gov/privacy/",
  },
}
